import React from 'react';
import PropTypes from 'prop-types';
import {SVGIcon} from '@homeaway/react-svg';
import {CABIN__24} from '@homeaway/svg-defs/lib/defs/CABIN__24';

import './Placeholder.less';

const Placeholder = ({svgIcon}) => (
    <div className="Placeholder">
        <SVGIcon markup={svgIcon} />
    </div>
);

Placeholder.propTypes = {
    svgIcon: PropTypes.string,
};

Placeholder.defaultProps = {
    svgIcon: CABIN__24,
};

export default Placeholder;
